import {useStyles} from './ElementRow.style';
import React from "react";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ElementRowProperties from "./ElementRowProperties";
import clsx from "clsx";

const ElementRow: React.FC<ElementRowProperties> = ({
                                                              deliveryTime,
                                                              onSelect,
                                                              className,
                                                              selected
                                                          }) => {
    const classes = useStyles();

    return (
        <div className={clsx(classes.element_row_container, className, selected && classes.active)}
             onClick={() => onSelect(deliveryTime)}>
            <div className={classes.icon_info}>
                <LocalShippingIcon/>
            </div>

            <div className={classes.text_container}>
                <div><b>{deliveryTime ?? 'Default'}</b></div>
            </div>

        </div>
    )
}


export default ElementRow;